import { render, staticRenderFns } from "./CategoriesView.vue?vue&type=template&id=24b9693a&scoped=true"
import script from "./CategoriesView.vue?vue&type=script&lang=js"
export * from "./CategoriesView.vue?vue&type=script&lang=js"
import style0 from "./CategoriesView.vue?vue&type=style&index=0&id=24b9693a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b9693a",
  null
  
)

export default component.exports